import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UpdateTranslationRequest } from '@cash-web/shared-util-protos/squareup/cash/cashlingo/core/core_service.pb'
import { UpdateTranslationResponse } from '@cash-web/shared-util-protos/squareup/cash/cashlingo/core/core_service.pb'

export const updateTranslation = (request: UpdateTranslationRequest, options?: CashRequestOptions) =>
  post<UpdateTranslationRequest, UpdateTranslationResponse>('/2.0/cash/update-translation', request, {
    ...options,
    rejectOnError: true,
  })
